"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPSFeedbackCategory = exports.WidgetMinVersion = void 0;
var WidgetMinVersion;
(function (WidgetMinVersion) {
    WidgetMinVersion[WidgetMinVersion["christmas-hat"] = 1.2] = "christmas-hat";
    WidgetMinVersion[WidgetMinVersion["countdown"] = 3] = "countdown";
    WidgetMinVersion[WidgetMinVersion["time-spent-on-page"] = 3.1] = "time-spent-on-page";
    WidgetMinVersion[WidgetMinVersion["search-and-replace"] = 1.1] = "search-and-replace";
    WidgetMinVersion[WidgetMinVersion["stick-on-scroll"] = 4.3] = "stick-on-scroll";
    WidgetMinVersion[WidgetMinVersion["popin-image"] = 1] = "popin-image";
    WidgetMinVersion[WidgetMinVersion["nps"] = 1] = "nps";
    WidgetMinVersion[WidgetMinVersion["progress-bar"] = 1] = "progress-bar";
    WidgetMinVersion[WidgetMinVersion["promotional-banner"] = 1] = "promotional-banner";
    WidgetMinVersion[WidgetMinVersion["popin-simple"] = 1] = "popin-simple";
    WidgetMinVersion[WidgetMinVersion["snowflakes"] = 2] = "snowflakes";
    WidgetMinVersion[WidgetMinVersion["social-proof"] = 1] = "social-proof";
    WidgetMinVersion[WidgetMinVersion["sharing-sidebar"] = 2.2] = "sharing-sidebar";
    WidgetMinVersion[WidgetMinVersion["tooltip"] = 1.1] = "tooltip";
    WidgetMinVersion[WidgetMinVersion["scroll-tracking"] = 3.2] = "scroll-tracking";
    WidgetMinVersion[WidgetMinVersion["element-visibility"] = 2.1] = "element-visibility";
    WidgetMinVersion[WidgetMinVersion["popin-video"] = 1] = "popin-video";
    WidgetMinVersion[WidgetMinVersion["virtual-click"] = 2.2] = "virtual-click";
    // No minimum version
    WidgetMinVersion[WidgetMinVersion["google-form-modal"] = 0] = "google-form-modal";
    WidgetMinVersion[WidgetMinVersion["iframe-click-tracking"] = 0] = "iframe-click-tracking";
    WidgetMinVersion[WidgetMinVersion["product-image-optimization"] = 0] = "product-image-optimization";
    // Disabled widgets
    WidgetMinVersion[WidgetMinVersion["interstitiel"] = 1] = "interstitiel";
    WidgetMinVersion[WidgetMinVersion["banner"] = 2] = "banner";
    WidgetMinVersion[WidgetMinVersion["modal"] = 3] = "modal";
    WidgetMinVersion[WidgetMinVersion["olark"] = 4] = "olark";
    WidgetMinVersion[WidgetMinVersion["zopim"] = 5] = "zopim";
    WidgetMinVersion[WidgetMinVersion["weather"] = 6] = "weather";
    WidgetMinVersion[WidgetMinVersion["responsive-sharing-buttons"] = 7] = "responsive-sharing-buttons";
})(WidgetMinVersion = exports.WidgetMinVersion || (exports.WidgetMinVersion = {}));
var NPSFeedbackCategory;
(function (NPSFeedbackCategory) {
    NPSFeedbackCategory["Promoters"] = "promoters";
    NPSFeedbackCategory["Detractors"] = "detractors";
    NPSFeedbackCategory["Passives"] = "passives";
})(NPSFeedbackCategory = exports.NPSFeedbackCategory || (exports.NPSFeedbackCategory = {}));
//# sourceMappingURL=types.js.map